<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button d-flex justify-content-between align-item-center"
    [ngClass]="{
      'bg-frozen border-frozen': cardToken.Frozen,
    }"
  >
    <div class="card-token-number" [ngClass]="textColor">
      <img alt="" class="card-type-image" src="{{ cardToken.CardType | cardTypeImageUrl }}" />

      ({{ cardToken.CardNumber.substring(12) }})
    </div>

    <a class="d-flex" [ngClass]="{ 'text-white': cardToken.Frozen }" [routerLink]="'/payment'">
      <span class="icon material-icons" [ngClass]="textColor">chevron_right</span>
    </a>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="ecash-button d-flex justify-content-center align-item-center">
    <a class="btn d-flex align-items-center p-0 m-0" [routerLink]="'/payment'">
      <span class="icon material-icons" [ngClass]="textColor">add_card</span>
      <span class="font-size-14 add-card-text" [ngClass]="textColor">{{ 'member.card.ecash.add' | translate }}</span>
    </a>
  </div>
</ng-template>
